<template>
    <div>
        <el-table
            :data="tableData"
            border
            style="width: 100%;max-height:300px;overflow:auto">
                <el-table-column
                    prop="extloginname"
                    label="账号名称"
                    min-width="160">
                </el-table-column>
                <el-table-column
                    prop="dwname"
                    label="单位名称"
                    min-width="180">
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="80">
                        <template slot-scope="scope">
                            <el-radio-group size="small" v-model="userId">
                                <el-radio-button :label="scope.row.code">选择</el-radio-button>
                            </el-radio-group>
                        </template>
                </el-table-column>
        </el-table>
        <div style="text-align:center;margin-top:30px">
            <el-button size="small" type="primary" @click="login">确定</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        bindInfo: {
            type: Object,
            default: {}
        },
        dwType: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        tableData:[],
        userId:'',
    }),
    methods: {
        login(){
            var that = this;
            if(that.dwType=='mobeil'){
                $.post(`${that.$store.getters.ageUrl}/api/auth/third/mobile/login`,{
                    userId:that.userId,
                }, function (data, res) {
                    if(data.result){
                        // 调用store.js的login方法
                        that.$store.dispatch('views/login',{obj:data.tdata});
                    }else{
                        if(data.msg){
                            ShowMsg(data.msg,'error');
                        }else{
                            ShowMsg(data.errors.captcha || data.errors.password,'error');
                        }
                    }
                })
            }
            
        }
    },
    mounted() {
        var that = this;
        // 获取单位信息  根据type判断是微信还是手机
        if(that.dwType=='mobeil'){
            that.$get(`${that.$store.getters.ageUrl}/api/auth/third/mobile/account`,that.bindInfo, function (data, res) {
                that.tableData = data.bindCountList;
            })
        }
    },
}
</script>